(function(jQuery) {
  jQuery(document).ready(($) => {
    const $blog =$('.category-blog .blog')
    $blog.isotope({
      masonry: {
        columnWidth: 'main article',
        gutter: '.grid-gutter'
      },
      itemSelector: 'main article',
    });

    // control loading of the images
    $blog.imagesLoaded().progress( function() {
      $('.category-blog .blog').isotope('layout');
    });
  });
})(jQuery)
